import { render, staticRenderFns } from "./KnownMeasureTranslationsPage.vue?vue&type=template&id=fd7819dc&"
import script from "./KnownMeasureTranslationsPage.vue?vue&type=script&lang=js&"
export * from "./KnownMeasureTranslationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports